interface StreetProps {
  width: number;
}

const Street = ({ width }: StreetProps) => {
  // Generate lane markings
  const markingCount = Math.ceil(width / 100);
  const markings = Array.from({ length: markingCount }, (_, i) => i);

  return (
    <div
      className="relative bg-gray-700"
      style={{
        width: `${width}px`,
        height: '80px',
      }}
    >
      {/* Road surface texture */}
      <div className="absolute inset-0 bg-gradient-to-b from-gray-600 via-gray-700 to-gray-800" />

      {/* Center lane markings (dashed yellow) */}
      <div className="absolute top-1/2 left-0 right-0 flex -translate-y-1/2">
        {markings.map((i) => (
          <div
            key={i}
            className="h-1 bg-yellow-400"
            style={{
              width: '40px',
              marginLeft: i === 0 ? '30px' : '60px',
            }}
          />
        ))}
      </div>

      {/* Top edge line */}
      <div className="absolute top-2 left-0 right-0 h-0.5 bg-white opacity-60" />

      {/* Bottom edge line */}
      <div className="absolute bottom-2 left-0 right-0 h-0.5 bg-white opacity-60" />

      {/* Sidewalk edges */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gray-400" />
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gray-400" />
    </div>
  );
};

export default Street;
